import $ from 'jquery'

$(document).ready(dhsv_vc_calculator_roi_v2())

function dhsv_vc_calculator_roi_v2() {
  $(
    '.dhsv_vc_calculator_roi_v2__material .dhsv_vc_calculator_roi_v2__material__range'
  ).on('change input', function () {
    $(this)
      .next('.dhsv_vc_calculator_roi_v2__material__range_count')
      .text($(this).val())
  })
}
